import { render } from "./EventTracking.vue?vue&type=template&id=f1c75a84&scoped=true"
import script from "./EventTracking.vue?vue&type=script&lang=js"
export * from "./EventTracking.vue?vue&type=script&lang=js"

import "./EventTracking.vue?vue&type=style&index=0&id=f1c75a84&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c75a84"]])

export default __exports__